import React from "react";

const SimCheckBox = ({ id, label, checked, onChange, disabled = false, TooltupText = "", ...rest }) => {
  return (
    <>
      <div className={`form-check simcheck ${disabled ? "disable" : ""}`}>
        <input
          className="form-check-input"
          type="checkbox"
          id={id}
          checked={checked}
          onChange={onChange}
          disabled={disabled} 
          {...rest}
          title={TooltupText}
        />
        {label && (
          <label className="form-check-label" htmlFor={id}>
            {label}
          </label>
        )}
      </div>
    </>
  );
};

export default SimCheckBox;
